// extracted by mini-css-extract-plugin
export default {"link":"navbutton_link__ziHc0","img":"navbutton_img__jZeVT","text":"navbutton_text__NiZk3"};